import { render, staticRenderFns } from "./dateList.vue?vue&type=template&id=385d0b1a&scoped=true&"
import script from "./dateList.vue?vue&type=script&lang=js&"
export * from "./dateList.vue?vue&type=script&lang=js&"
import style0 from "./dateList.vue?vue&type=style&index=0&id=385d0b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385d0b1a",
  null
  
)

export default component.exports